import DownloadView from "@/views/download/DownloadView";
import DownloadOverview from "@/views/download/DownloadOverview";
import DownloadList from "@/views/download/DownloadList";
import DownloadFile from "@/views/download/DownloadFile";

export const downloadRoutes = {
  path: '/download',
  name: 'DownloadView',
  component: DownloadView,
  children: [
    {
      path: 'overview',
      name: 'DownloadOverview',
      component: DownloadOverview,
      meta: { title: "Download Overview - TAIR" },
    },
    {
      path: "list",
      name: "DownloadList",
      component: DownloadList,
      meta: { title: "Download Files - TAIR" },
    },
    {
      path: 'file',
      name: 'DownloadFile',
      component: DownloadFile,
      meta: { title: "View File - TAIR" },
    }
  ]
}